export default __webpack_public_path__ + "static/media/submenu_3_off.59f523d9.svg";